import React from 'react'
import { FacebookIcon, FacebookMessengerIcon, FacebookMessengerShareButton, FacebookShareButton, TelegramIcon, TelegramShareButton, ViberIcon, ViberShareButton, WhatsappIcon, WhatsappShareButton } from 'react-share'


const UserShareBtn = ({ userID, userName }) => {
  const url = `https://www.thriftstorenepal.com/products/userallproducts/${userName}/${userID}`
  // const url = `http://localhost:3000/products/userallproducts/${userName}/${userID}`
  return (
    <div className='d-flex gap-3 '>

      <FacebookShareButton url={url} quote=" hello">
        <FacebookIcon size={30} className='rounded-circle' />
      </FacebookShareButton>

      <FacebookMessengerShareButton url={url}>
        <FacebookMessengerIcon size={30} className='rounded-circle' />
      </FacebookMessengerShareButton>

      <TelegramShareButton url={url} quote=" hello">
        <TelegramIcon size={30} className='rounded-circle' />
      </TelegramShareButton>


      <WhatsappShareButton url={url}>
        <WhatsappIcon size={30} className='rounded-circle' />
      </WhatsappShareButton>

      <ViberShareButton url={url}>
        <ViberIcon size={30} className='rounded-circle' />
      </ViberShareButton>
    </div>
  )
}

export default UserShareBtn
